/**
 * Minimal pub/sub bus. Cart drawer, cart page, header bag count and any
 * free-shipping progress UI all subscribe to `NantesEvents.cartUpdate`
 * instead of importing/calling each other directly.
 */
const subscribers = {};

function subscribe(eventName, callback) {
  if (!subscribers[eventName]) subscribers[eventName] = [];
  subscribers[eventName] = [...subscribers[eventName], callback];
  return () => {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (!subscribers[eventName]) return;
  subscribers[eventName].forEach((callback) => callback(data));
}

window.NantesPubSub = { subscribe, publish };
